
<template>
    <div class="card flex justify-content-center">
        <Dialog v-model:visible="visible" modal :header="$t('dialogs.private_channel_title')" :style="{ width: '25rem' }">
            <span class="p-text-secondary block mb-5">{{ this.$t('dialogs.private_channel_subtitle') }} # {{ channel.name }}.</span>
            <div class="flex align-items-center gap-3 mb-3">
                <label for="channel_password" class="font-semibold w-6rem">{{ this.$t('dialogs.private_channel_label') }}</label>
                <InputText id="channel_password" class="flex-auto" autocomplete="off" v-model="password"/>
            </div>
            <Message severity="warn" v-if="showAlert">{{ this.$t('dialogs.private_channel_warning') }} </Message>
            <div class="flex justify-content-end gap-2">
                <Button type="button" :label="$t('dialogs.private_channel_okey')"  @click="sendPassword" ></Button>
                <Button type="button" :label="$t('dialogs.private_channel_cancel')" severity="secondary" @click="visible = false"></Button>
            </div>
        </Dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible:false,
            channel: {},          
            showAlert: false,
            password: ''
        };
    },
    methods: {
        openDialog() {
            this.showAlert = false;
            this.password = '';
            this.visible = true;
        
        },
        sendPassword() {
            if (this.password.length > 0) {
                this.showAlert = true;
                this.visible = false;
                this.$socket.emit('join',{id: this.channel.id, password: this.password, name: this.channel.name});
            } else {
                this.showAlert = true;
            }
        }
    }
};
</script>
